exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#contactForm[data-v-497a1631]{color:#000}", ""]);

// exports
